<div class="mainDiv">
  <div class="row">
    <div
      class="mainTxt d-flex justify-content-center mt-3"
      style="color: #f3a43f; font-size: 48px; font-weight: 500"
    >
      Saved Choir Sessions
    </div>
    <div class="search_Div mt-4 d-flex justify-content-center mb-4">
      <div class="search-container">
        <input
          type="text"
          placeholder="Search"
          [(ngModel)]="searchText"
          (keyup)="getSavedChoirList(searchText)"
        />
        <span class="search-icon">🔍</span>
      </div>
    </div>
  </div>

  <div class="row m-0 p-0 pb-5">
    <div class="card col-md-4" *ngFor="let item of ChoirList">
      <div class="card-image">
        <img
          src="{{
            item?.profilePic
              ? item?.profilePic
              : '../../../../../assets/images/dummy_Pic.svg'
          }}"
          style="height: 250px; width: 360px"
          alt="Choir"
        />
      </div>
      <div class="card-content">
        <div class="datDiv d-flex">
          <span class="date">{{
            convertSecondsToDate(item?.startDateInSeconds)
          }}</span>
          <!-- {{
              startDateInSeconds * 1000 | date : "medium" : "23 August 2024"
            }} -->
          <span class="price">${{ item?.amount ? item?.amount : "0" }}</span>
        </div>

        <h2 class="card-title">{{ item?.title }}</h2>

        <p class="card-description">
          {{ item?.description }}
        </p>
        <div class="applyBtn p-4">
          <a
            href="#"
            class="apply-btn"
            [routerLink]="['/main/choir-detail']"
            [queryParams]="{ id: item?.choirId }"
            >Apply Now</a
          >
        </div>
      </div>
    </div>
    <!-- <div class="card col-md-4">
        <div class="card-image">
          <img src="../../../assets/images/dummyImage2.png" alt="Choir" />
        </div>
        <div class="card-content">
          <div class="datDiv d-flex">
            <span class="date">5 August 2024</span>
            <span class="price">$889.89</span>
          </div>
          <h2 class="card-title">Beginner Choir <span>(4 weeks)</span></h2>
  
          <p class="card-description">
            Lorem ipsum is simply dummy text of the printing and typesetting
            industry. Lorem ipsum....
          </p>
          <div class="applyBtn p-4">
            <a href="#" class="apply-btn">Apply Now</a>
          </div>
        </div>
      </div>
      <div class="card col-md-4">
        <div class="card-image">
          <img src="../../../assets/images/dummyImage3.png" alt="Choir" />
        </div>
        <div class="card-content">
          <div class="datDiv d-flex">
            <span class="date">5 August 2024</span>
            <span class="price">$889.89</span>
          </div>
          <h2 class="card-title">Beginner Choir <span>(4 weeks)</span></h2>
  
          <p class="card-description">
            Lorem ipsum is simply dummy text of the printing and typesetting
            industry. Lorem ipsum....
          </p>
          <div class="applyBtn p-4">
            <a href="#" class="apply-btn">Apply Now</a>
          </div>
        </div>
      </div>
      <div class="card col-md-4">
        <div class="card-image">
          <img src="../../../assets/images/dummyImage5.svg" alt="Choir" />
        </div>
        <div class="card-content">
          <div class="datDiv d-flex">
            <span class="date">5 August 2024</span>
            <span class="price">$889.89</span>
          </div>
          <h2 class="card-title">Beginner Choir <span>(4 weeks)</span></h2>
  
          <p class="card-description">
            Lorem ipsum is simply dummy text of the printing and typesetting
            industry. Lorem ipsum....
          </p>
          <div class="applyBtn p-4">
            <a href="#" class="apply-btn">Apply Now</a>
          </div>
        </div>
      </div> -->
  </div>
</div>
